import { render, staticRenderFns } from "./AsideMenuTab.vue?vue&type=template&id=7da91e28&scoped=true&"
import script from "./AsideMenuTab.vue?vue&type=script&lang=js&"
export * from "./AsideMenuTab.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenuTab.vue?vue&type=style&index=0&id=7da91e28&scoped=true&lang=scss&"
import style1 from "./AsideMenuTab.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7da91e28",
  null
  
)

export default component.exports